import React, { FC, useEffect, useMemo, useState } from 'react'
import { Button, Checkbox, Form, message, Modal, Progress } from 'antd'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import Store, { AppStore } from 'src/pc/store/AppStore'
import { CheckCircleOutlined } from '@ant-design/icons'
import { GetChannel } from 'src/commons/utils'
import {
  CreateOrderJavaHttpHS,
  createPayHS,
  CreateThirdOrderHS,
  JsqProductHS,
  UserInfoHS,
} from 'src/commons/store/UserStore'
import {
  commonJump,
  isLogged,
  needClient,
  showAgreementModal,
  showBindMobile,
  toBoosterBuyDetailUrl,
} from 'src/pc/store/UIController'
import { checkOrderPayStatus, getUserInfo } from 'src/pc/store/UserStore'
import { JsqContent } from 'src/commons/utils/DOMUtils'
import { GetPreProcessHS } from 'src/commons/store/BasisStore'
import DDImage from 'src/pc/components/dd-image'
import DDInput from 'src/pc/components/dd-input'
import PayOrder from 'src/pc/components/PayOrder'
import usePageRefreshCache from 'src/pc/components/hooks/usePageRefreshCache'
import useIsBindMobile from 'src/pc/components/hooks/useIsBindMobile'
import UseBalance from 'src/pc/components/Buy/UseBalance'
import awrrosLeft from 'src/pc/assets/images/joinVIP/awrrosLeft.png'
import awrrosRight from 'src/pc/assets/images/joinVIP/awrrosRight.png'
import useCreateOrderAndPay from 'src/pc/components/hooks/useCreateOrderAndPay'
import useSwitchPayTips from 'src/pc/components/hooks/useSwitchPayTips'
import BoosterArrows from 'src/pc/assets/icons/booster-arrows.svg'
import styled from '@emotion/styled'
import classNames from 'classnames'
import { getPhpToken } from 'src/pc/utils/auth'

const JSQ_PRODUCT_CARD_WIDTH = 180
const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: { span: 18 },
}
const tailFormItemLayout = {
  wrapperCol: {
    offset: 4,
  },
}
let stopOrder: Function | null = null

export const runSpeedClient = (data?: JsqProduct & { extend?: string }) => {
  if (!data) {
    return
  }
  const {
    speeddownload,
    productid,
    downloadname,
    downloadextname,
    md5,
    installpath,
    relativepath,
    cmdline,
    installparam,
    shortcut,
    RegInstallPath,
    isDefault,
    extend,
  } = data
  const userInfo = UserInfoHS.SuccessResult
  console.log('userInfo', userInfo?.bindMobile)
  if (window.FuluApp) {
    window.FuluApp.JSNotifyCppFunc(
      'start_3rd_speed',
      productid,
      downloadname,
      downloadextname,
      speeddownload,
      md5,
      installpath,
      relativepath,
      cmdline,
      installparam,
      shortcut,
      RegInstallPath,
      extend ||
        JSON.stringify({
          userInfo: null,
          source: 'normal',
          mobile: userInfo?.bindMobile ? '' : userInfo?.mobile ?? '',
          token: getPhpToken(),
        }),
      '',
    )
    AppStore.SpeedClientDownloadProgress[productid] = 1
    if (isDefault === '1' && AppStore.settings.showSpeed) {
      AppStore.speedBall?.show()
    }
  } else {
    needClient()
  }
}

const Booster: FC = () => {
  const [currentJsqProductIndex, setCurrentJsqProductIndex] = usePageRefreshCache<number>(
    'store-booster-jsqProductIndex',
    0,
    true,
  )
  const [sliderIndex, setSliderIndex] = useState<number>(0)
  const [boosterBuyVisible, setBoosterBuyVisible] = useState<boolean>(false)
  const [readyBuy, setReadyBuy] = useState(false)
  const [payWay, setPayWay] = useState<TPayWay>('alipay')
  const [currentBuyTheGoods, setCurrentBuyTheGoods] = useState<JsqProductGood>()
  const [balanceType, setBalanceType] = useState<0 | 1 | -1>(0)
  const [qrcode, setQrcode] = useState<string>('')
  const [agentAccount, setAgentAccount] = useState<string>('')
  const [form] = Form.useForm()
  const { isNeedTips, reloadFlag } = useSwitchPayTips()
  const { isBindMobile } = useIsBindMobile()
  const history = useHistory()
  const jsqProductList = JsqProductHS.SuccessResult
  const currentJsqProductInfo: JsqProduct | null = jsqProductList?.[Number(currentJsqProductIndex)]?.properties || null
  const isHaiSha = currentJsqProductInfo?.isHaiSha === '1'
  const isAgentBuy = currentJsqProductInfo?.isRecharge
  const userInfo = UserInfoHS.SuccessResult
  const { SpeedClientInstallStatus, SpeedClientDownloadProgress } = AppStore
  const {
    createOrderLoading,
    OrderPayVisible,
    payUrl,
    createJavaOrder,
    OrderCancel: agentOrderCancel,
  } = useCreateOrderAndPay('alipay')
  const orderPrice = useMemo(() => {
    if (currentBuyTheGoods) {
      return Number(currentBuyTheGoods.price.toFixed(2))
    }
    return 0
  }, [currentBuyTheGoods])
  const finalPayPrice = useMemo(() => {
    if (userInfo && !isAgentBuy) {
      if (balanceType === 0) {
        return Number((orderPrice - userInfo.balance).toFixed(2))
      }
      if (balanceType === 1) {
        return Number((orderPrice - userInfo.cash).toFixed(2))
      }
    }
    return orderPrice
  }, [orderPrice, userInfo, balanceType, isAgentBuy])
  const toBannerUrl = () => {
    AppStore.JsqConfig?.newUrl && commonJump(AppStore.JsqConfig.newUrl, true)
  }
  const buyJsqProduct = async (goods: JsqProductGood) => {
    if (isAgentBuy && !agentAccount) {
      return message.warn('该商品需要先填写充值账号')
    }
    await isLogged()
    toBoosterBuyDetailUrl(goods.id)
  }
  const orderCancel = () => {
    stopOrder?.()
    setBoosterBuyVisible(false)
    setReadyBuy(false)
  }
  const balanceTypeChange = (type: 0 | 1 | -1) => {
    setBalanceType(type)
    setReadyBuy(false)
    stopOrder?.()
  }
  const buyBoosterSubmit = async () => {
    await isLogged()
    if (!isBindMobile) {
      return showBindMobile()
    }
    setReadyBuy(true)
    currentBuyTheGoods && createSpeedOrder(currentBuyTheGoods.id, payWay)
  }

  const createSpeedOrder = async (gameId: number, payWay: TPayWay) => {
    const PreProcessInfo = GetPreProcessHS.SuccessResult
    const token = await isLogged()
    try {
      stopOrder?.()
      const createJavaOrderHttpResult = await CreateOrderJavaHttpHS.Execute({
        num: 1,
        gameId,
        useBalance: balanceType === -1 || isAgentBuy ? 0 : 1,
        balanceType: balanceType === -1 || isAgentBuy ? undefined : balanceType,

        downloadId: PreProcessInfo?.id,
        orderType: isHaiSha ? 41 : isAgentBuy ? 38 : 13,
        channel: GetChannel(),
        ...(localStorage.getItem('notificationClick') ? { ordSource: 3 } : {}),
        ...(isAgentBuy ? { information: JSON.stringify({ account: agentAccount }) } : {}),
      })

      const success = (data?: CheckGameOrderStatus) => {
        orderCancel()
        AppStore.SpeedModalVisible = false
        getUserInfo(token)
        if (isAgentBuy) {
          return message.success('充值成功，请登录您的网易UU加速器查看')
        }
        const ModalInstace = isHaiSha
          ? Modal.success({
            icon: null,
            zIndex: 1008,
            width: 434,
            title: (
              <div className="success-tip-title">
                <CheckCircleOutlined />
                  购买成功
              </div>
            ),
            content: (
              <>
                <div className="jsq-success-content">
                  <div className="product-name">
                    <span>{currentJsqProductInfo?.title}</span>
                    <span className="product-time">{currentBuyTheGoods?.['product_name']}</span>
                  </div>
                  <div className="buyTips">去我的游戏库启动游戏加速吧</div>
                </div>
              </>
            ),
            className: 'jsq-custom custom SpeedBuySuccess Waiting AllowClose',
            okText: '前往我的游戏库',
            onOk: () => {
              commonJump('/my-game')
            },
          })
          : Modal.success({
            icon: null,
            zIndex: 1008,
            width: 434,
            title: (
              <>
                <img draggable={false} src={currentJsqProductInfo?.logo} alt={data?.['product_name']} />
                {data?.['product_name']}
              </>
            ),
            content: (
              <>
                <div className="successTips">
                  <CheckCircleOutlined />
                    购买成功
                </div>
                {data?.cdk?.[0] ? (
                  JsqContent(data.cdk)
                ) : (
                  <div
                    onClick={() => {
                      commonJump('/User/order')
                      ModalInstace.destroy()
                    }}
                    style={{
                      color: '#ef4c25',
                      fontSize: 14,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      textAlign: 'center',
                      marginTop: 20,
                    }}
                  >
                      请前往【我的订单】提取激活码
                  </div>
                )}
              </>
            ),
            className: 'custom SpeedBuySuccess Waiting AllowClose',
            okText: '如何激活',
            onOk: () => {
              if (Store.isInClient) {
                  window?.FuluApp?.JSNotifyCppFunc('open_url', 'https://www.yuque.com/yxgj/support/piuckq#jkCtz')
              } else {
                window.open('https://www.yuque.com/yxgj/support/piuckq#jkCtz', '_blank')
              }
            },
          })
      }

      const orderNo = createJavaOrderHttpResult.orderNo

      if (createJavaOrderHttpResult.hasThridPay !== 0) {
        const formatPayMethod = formatJavaPayMethod(payWay)
        const javaPayLaunchResult = await createPayHS.Execute({
          balanceNo: createJavaOrderHttpResult.balanceNo,
          payMode: formatPayMethod,
        })

        setQrcode(javaPayLaunchResult)
      }

      stopOrder = checkOrderPayStatus(
        { token, order_no: orderNo },
        data => {
          success(data)
        },
        () => {
          message.warning('支付订单超时!')
          orderCancel()
        },
      )
    } catch (error) {
      message.warn(error.message)
      console.log(error)
    }
  }
  const formatJavaPayMethod = (payWay: TPayWay) => {
    switch (payWay) {
      case 'alipay':
        return 'alipay_scan'
      case 'wechat':
        return 'wechat_scan'
      case 'qq_wallet':
        return 'qq_scan'
    }
    return 'alipay_scan'
  }
  const changePayWay = (payWay: TPayWay) => {
    isNeedTips(payWay, true)
    stopOrder?.()
    setPayWay(payWay)
    setReadyBuy(false)
    if (currentBuyTheGoods) {
      setBoosterBuyVisible(true)
    }
  }

  useEffect(() => {
    setSliderIndex(0)
  }, [currentJsqProductIndex])
  useEffect(() => {
    JsqProductHS.Execute()
  }, [])
  return (
    <StyledBoosterContainer>
      <StyledBoosterBanner onClick={() => toBannerUrl()}>
        {AppStore.JsqConfig && (
          <DDImage
            src={`${AppStore.JsqConfig.newLogo}?x-oss-process=image/resize,m_lfit,h_${200},w_${1000}/format,jpg`}
          />
        )}
      </StyledBoosterBanner>
      <StyledJsqTabsHeaderRow>
        {jsqProductList?.map((d, i) => {
          if (i > 4) {
            return null
          }
          const productId = d.properties.productid
          const isDownloading =
            SpeedClientDownloadProgress[productId] > 0 && SpeedClientDownloadProgress[productId] < 100
          const isStarting = SpeedClientInstallStatus[productId] === 2
          return (
            <StyledJsqTabsHeaderItem
              key={i}
              onClick={() => setCurrentJsqProductIndex(i)}
              className={classNames({ active: Number(currentJsqProductIndex) === i })}
              style={{ background: `url(${d.properties.bgImg})` }}
            >
              <StyledJsqTabsHeaderItemLeft>
                <div className={'logo'}>
                  <img src={d.properties.logo} />
                </div>
                {(isDownloading || isStarting) && (
                  <div className={classNames('progress', { loading: isStarting })}>
                    <Progress
                      type="circle"
                      percent={isStarting ? 25 : SpeedClientDownloadProgress[productId]}
                      width={58}
                      strokeColor={'#1c88b6'}
                      trailColor={'#393f47'}
                      strokeWidth={5}
                    />
                  </div>
                )}
                {!(SpeedClientInstallStatus[productId] === 2 || isDownloading) && (
                  <div
                    className="btn"
                    onClick={e => {
                      e.stopPropagation()
                      runSpeedClient(d.properties)
                    }}
                  >
                    一键加速
                  </div>
                )}
              </StyledJsqTabsHeaderItemLeft>
              <StyledJsqTabsHeaderItemRight>
                <div className="name">{d.properties.title}</div>
                <div className="description">
                  {isDownloading ? (
                    <>
                      正在下载<span>({SpeedClientDownloadProgress[productId]}%)</span>
                    </>
                  ) : isStarting ? (
                    <span>启动中…</span>
                  ) : (
                    d.properties.discription
                  )}
                </div>
              </StyledJsqTabsHeaderItemRight>
            </StyledJsqTabsHeaderItem>
          )
        })}
      </StyledJsqTabsHeaderRow>
      <StyledJsqContentBox style={{ height: isAgentBuy ? 332 : isHaiSha ? 306 : 276 }}>
        {isAgentBuy && (
          <StyledAgentInputBox>
            <div className="label">充值账号</div>
            <div className="value">
              <DDInput
                value={agentAccount}
                onChange={e => setAgentAccount(e.target.value)}
                placeholder="请填写您要充值到的网易UU加速器账号"
              />
            </div>
          </StyledAgentInputBox>
        )}
        <StyledJsqViewContent>
          <StyledJsqContent style={{ transform: `translateX(-${sliderIndex * JSQ_PRODUCT_CARD_WIDTH}px)` }}>
            {currentJsqProductInfo?.goods.map(d => {
              return (
                <StyledJsqCardItem key={d.id}>
                  <div className="header">{d.product_name}</div>
                  <div className="unit-price">
                    <span className="primary">{Number((d.price / d.unit).toFixed(2))}元</span>/
                    {currentJsqProductInfo.unit}
                  </div>
                  <div className="final-price">
                    <div className="price">优惠价:￥{d.price}</div>
                    <div className="source-price">￥{d.source_price}</div>
                  </div>
                  <div className="btn" onClick={() => buyJsqProduct(d)}>
                    立即购买
                  </div>
                </StyledJsqCardItem>
              )
            })}
          </StyledJsqContent>
        </StyledJsqViewContent>
        {currentJsqProductInfo && currentJsqProductInfo.goods.length > 5 && (
          <>
            {sliderIndex !== 0 && (
              <StyledJsqViewArrows className="left" onClick={() => setSliderIndex(Math.max(sliderIndex - 1, 0))}>
                <BoosterArrows />
              </StyledJsqViewArrows>
            )}
            {sliderIndex + 5 !== currentJsqProductInfo.goods.length && (
              <StyledJsqViewArrows
                className="right"
                onClick={() => setSliderIndex(Math.min(sliderIndex + 1, currentJsqProductInfo.goods.length - 5))}
              >
                <BoosterArrows />
              </StyledJsqViewArrows>
            )}
          </>
        )}
        {isHaiSha && (
          <StyledJsqDescription>
            温馨提示：改加速器目前仅支持《绝地求生》、《使命召唤17》，更多支持游戏尽情期待
          </StyledJsqDescription>
        )}
      </StyledJsqContentBox>
      <StyledSpeedBuyModal
        className="custom"
        title="加速器购买"
        maskClosable={false}
        centered
        width={580}
        zIndex={1007}
        footer={false}
        visible={boosterBuyVisible}
        onCancel={orderCancel}
      >
        <StyledSpeedBuyType
          {...formItemLayout}
          onFinish={buyBoosterSubmit}
          className="custom"
          initialValues={{ Agreement: true }}
          form={form}
        >
          <Form.Item label="商品" className="notBottom">
            {currentJsqProductInfo?.title}-{currentBuyTheGoods ? currentBuyTheGoods.product_name : ''}
            <span>¥{currentBuyTheGoods?.price}/个</span>
          </Form.Item>
          <Form.Item label="订单金额" className="notBottom">
            <b style={{ lineHeight: '32px' }}>¥{orderPrice}</b>
            {!isAgentBuy && (
              <UseBalance
                className="SpeedBuyType-UseBalance"
                style={{ marginTop: 20, marginBottom: 20 }}
                BalanceType={balanceType}
                onChang={balanceTypeChange}
              />
            )}
          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button htmlType="submit" disabled={readyBuy}>
              确认下单
            </Button>
            <Form.Item
              name="Agreement"
              valuePropName="checked"
              noStyle
              rules={[
                {
                  required: true,
                  message: `您需要同意《${AppStore.AgreementConfig.sale?.title}》`,
                  type: 'boolean',
                  transform: value => value || undefined,
                },
              ]}
            >
              <Checkbox />
            </Form.Item>
            <a draggable={false} style={{ color: '#a1a1a1' }} onClick={() => showAgreementModal('sale')}>
              《{AppStore.AgreementConfig.sale?.title}》
            </a>
          </Form.Item>
        </StyledSpeedBuyType>
      </StyledSpeedBuyModal>
    </StyledBoosterContainer>
  )
}

const StyledJsqDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
  font-size: var(--fontsize-14);
  color: var(--text-color-2);
`

const StyledAgentInputBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .label {
    font-size: var(--fontsize-14);
    color: var(--text-color-2);
    margin-right: 10px;
  }
`

const StyledSpeedBuyModal = styled(Modal)`
  &.custom {
    .ant-modal-header {
      padding-top: 12px;
    }
    .ant-modal-content {
      background-image: radial-gradient(circle at center top, rgb(30, 26, 17) 24%, rgb(0, 0, 0) 100%);
      border: 1px solid #362f1f;
    }
    .ant-modal-title {
      background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(#cd9445), to(#f5d1a3));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 20px;
      &:before,
      &:after {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 145px;
        height: 18px;
      }
      &:before {
        background-image: url(${awrrosLeft});
        margin-right: 20px;
      }
      &:after {
        margin-left: 20px;
        background-image: url(${awrrosRight});
      }
    }
  }
  .ant-input-number {
    width: 130px;
    margin-right: 8px;
    background-color: transparent;
    border-color: #404040;
    color: #fff;
    input::placeholder {
      color: #ddd;
    }
  }
  .ant-input-number-handler-wrap {
    background-color: transparent;
  }
  .ant-input-number-handler > i {
    color: #fff;
  }
`
const StyledSpeedBuyType = styled(Form)`
  background-color: #1a1a1a;
  margin-bottom: 24px;
  padding: 10px 0;
  .notBottom {
    margin-bottom: 0;
  }
  .UserBalance {
    b {
      font-size: 18px;
      margin-right: 16px;
    }
    .ant-checkbox-wrapper {
      font-size: 14px;
    }
    .ant-checkbox {
      &-checked {
        .ant-checkbox-inner {
          border-color: var(--main-color);
          &:after {
            border-color: var(--main-color);
          }
        }
      }
    }
  }
  .ant-checkbox-wrapper {
    color: #a1a1a1;
    a {
      color: #a1a1a1;
    }
    .ant-checkbox-inner {
      background-color: transparent;
      border-color: #464646;
      &:after {
        border-color: #464646;
      }
    }
    + a {
      color: #999;
    }
  }
  .tips {
    margin-left: 6px;
    font-size: 12px;
  }
  .ant-radio-button-wrapper {
    padding: 0;
    width: 32px;
    height: 32px;
    text-align: center;
    background: #404040;
    border: 1px solid #404040;
    span {
      color: #fff;
      font-size: 14px;
    }
    &:not(:last-child) {
      margin-right: 12px;
    }
    &:before {
      display: none;
    }
    &-checked {
      border-color: var(--main-color);
      span {
        color: var(--main-color);
      }
    }
    &:not(.ant-radio-button-wrapper-disabled):first-of-type {
      border-color: #404040;
    }
  }
  .ant-checkbox {
    margin-left: 20px;
  }
  .SpeedBuyType-UseBalance {
    margin-left: 0;
  }
`

const StyledJsqViewArrows = styled.div`
  width: 30px;
  height: 68px;
  background: var(--bg-color-2);
  border-radius: 15px;
  position: absolute;
  top: 104px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background: var(--bg-color-3);
  }
  &.left {
    left: 15px;
  }
  &.right {
    right: 15px;
    transform: rotate(180deg);
  }
`

const StyledJsqCardItem = styled.div`
  width: ${JSQ_PRODUCT_CARD_WIDTH - 10}px;
  min-width: ${JSQ_PRODUCT_CARD_WIDTH - 10}px;
  height: 236px;
  background: var(--bg-color-2);
  border-radius: 4px;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
  .header {
    height: 52px;
    background: var(--bg-color-2);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--fontsize-18);
    font-weight: bold;
    color: var(--main-color);
    line-height: var(--fontsize-18);
  }
  .unit-price {
    text-align: center;
    margin-top: 20px;
    font-size: var(--fontsize-14);
    color: var(--text-color-1);
    .primary {
      font-size: 24px;
      font-weight: bold;
      line-height: 24px;
    }
  }
  .final-price {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .price {
      font-size: var(--fontsize-14);
      color: var(--text-color-1);
      line-height: var(--fontsize-14);
      margin-right: 12px;
    }
    .source-price {
      font-size: var(--fontsize-14);
      color: var(--text-color-3);
      line-height: var(--fontsize-14);
      text-decoration: line-through;
    }
  }
  .btn {
    margin: 30px auto 0;
    width: 120px;
    height: 36px;
    background: var(--bg-color-4);
    border-radius: 20px;
    border: 1px solid var(--text-color-3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--fontsize-14);
    line-height: var(--fontsize-14);
    color: var(--text-color-1);
    cursor: pointer;
    transition: background 300ms ease 0s;
    &:hover {
      border: none;
      background: linear-gradient(
        270deg,
        var(--main-btn-gradient-dark-color) 0%,
        var(--main-btn-gradient-light-color) 100%
      );
      color: var(--main-btn-text-color);
    }
  }
`

const StyledJsqContent = styled.div`
  height: 236px;
  display: flex;
  position: absolute;
  transition: all 300ms ease 0s;
`

const StyledJsqViewContent = styled.div`
  width: 890px;
  height: 236px;
  overflow: hidden;
  position: relative;
`

const StyledJsqContentBox = styled.div`
  width: 1000px;
  height: 276px;
  background: linear-gradient(166deg, var(--bg-color-1) 0%, #333333 100%);
  border-radius: 0px 4px 4px 0px;
  padding: 20px 55px;
  position: relative;
`

const StyledJsqTabsHeaderItemRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .name {
    font-size: var(--fontsize-14);
    color: var(--text-color-1);
    line-height: var(--fontsize-14);
  }
  .description {
    font-size: var(--fontsize-12);
    color: var(--text-color-2);
    margin-top: 10px;
    line-height: var(--fontsize-12);
    span {
      color: #00bfff;
    }
  }
`

const StyledJsqTabsHeaderItemLeft = styled.div`
  margin-right: 10px;
  position: relative;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    width: 44px;
    height: 44px;
    position: relative;
    z-index: 2;
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .progress {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .loading {
    animation: loading 1s infinite linear;
  }
  .btn {
    width: 60px;
    height: 18px;
    position: absolute;
    background: #212121;
    border-radius: 14px;
    border: 1px solid #27b6d1;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    line-height: 16px;
    color: #27b6d1;
    bottom: -6px;
    font-size: 12px;
    z-index: 3;
    transition: all 0.3s;
    &:hover {
      background: #27b6d1;
      color: #fff;
    }
  }
  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const StyledJsqTabsHeaderItem = styled.div`
  padding: 10px;
  width: 192px;
  height: 86px;
  background: var(--bg-color-2);
  border-radius: 4px 4px 0px 0px;
  cursor: pointer;
  margin-right: 10px;
  display: flex;
  align-items: center;
  position: relative;
  &:last-child {
    margin-right: 0;
  }
  &.active {
    &::before {
      content: ' ';
      width: 100%;
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: var(--main-color);
    }
  }
`

const StyledJsqTabsHeaderRow = styled.div`
  display: flex;
  align-items: center;
`

const StyledBoosterBanner = styled.div`
  width: 1000px;
  height: 200px;
  cursor: pointer;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
  }
`

const StyledBoosterContainer = styled.div`
  width: 1000px;
  margin: 0 auto;
  transition: all 0.3s;
`

export default hot(observer(Booster))
